import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ButtonStyle } from './style';
import { black500 } from '../../../constants/color';
export const WarningButton = ({ children, disabled, onClick, mt = 0, mb = 0, type = 'button' }) => {
    return (_jsx(Box, { component: 'button', onClick: onClick, width: '100%', mb: mb, type: type, sx: {
            ...ButtonStyle,
            mt: `${mt}px`,
            background: disabled ? '#FFEAB2' : '#FDBCBC',
            border: disabled ? '1px solid #FDBCBC' : 'none',
            cursor: disabled ? 'not-allowed' : 'pointer'
        }, children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: children }) }));
};
